import { createSelector } from 'reselect';

export const getAuditData = createSelector(({ audit }) => audit?.data.flatMap(transaction => transaction.SubTransaction.flatMap(subTransaction => ({
  TransactionID: transaction.TransactionID,
  ChangeTimeStamp: transaction.ChangeTimeStamp,
  RealUser: transaction.RealUser,
  ImpersonatedUser: transaction.ImpersonatedUser,
  ...subTransaction,
}))), result => result);

export const selectAuditID = createSelector(({ audit }) => audit?.UniqueID, result => result);

export const selectAuditEntityId = createSelector(({ audit }) => audit?.EntityID, result => result);
